module.exports = __webpack_public_path__ + "static/fg-06b13ee120605f9fdcc985667b5d3f0b.png";